export default {
      id: "fire-usage",
      viewBox: "0 0 250.74 356.63",
      url: __webpack_public_path__ + "img/icons.svg#fire",
      toString: function () {
        return this.url;
      }
    }